import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getAccountQuotas({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/quota",
        method: "GET",
      });

      commit(MutationsType.SET_QUOTAS, response.data.data);
    } catch (error) {
      console.error("getQuotas: ", error);
      throw error.response.data;
    }
  },
  resetModuleQuotas({ commit }) {
    commit(MutationsType.SET_QUOTAS, null);
  },
};
